// extracted by mini-css-extract-plugin
export var copyableField = "_ot-4";
export var customerBadge = "_ot-0";
export var customerInfoTitle = "_ot-2";
export var details = "_ot-1";
export var dropdownContainer = "_ot-5";
export var dropdownImage = "_ot-6";
export var editAssigneeForm = "_ot-a";
export var editButton = "_ot-3";
export var email = "_ot-7";
export var hidden = "_ot-d";
export var input = "_ot-8";
export var saveButton = "_ot-b";
export var shopifyIcon = "_ot-c";
export var suggestionBadge = "_ot-e";
export var suggestionText = "_ot-f";
export var username = "_ot-9";